module.exports = __webpack_public_path__ + "static/media/1323866.5307e75c.jpg";